module.exports = __webpack_public_path__ + "img/lang_en.80143785.svg";